import { BaseIcon } from './BaseIcon';
import { ReactComponent as svg } from './svgIcons/visibility_off.svg';

export const VisibilityOffIcon = ({ ...props }) => (
  <BaseIcon svg={svg} {...props} />
);
